
import { DataImport } from "./DataImport";
import { DataExport } from "./DataExport";

interface ImportExportTabsProps {
  activeTab: "import" | "export";
}

export function ImportExportTabs({ activeTab }: ImportExportTabsProps) {
  return (
    <div className="w-full">
      {activeTab === "import" ? <DataImport /> : <DataExport />}
    </div>
  );
}
